import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { take } from 'redux-saga/effects';
import getHash from '../internal/get-hash';
import createSagaManager from '../internal/create-saga-manager';
import { CONNECT_READMODEL, DISCONNECT_READMODEL } from '../internal/action-types';
import connectReadModelSaga from './connect-read-model-saga';
import disconnectReadModelSaga from './disconnect-read-model-saga';

var readModelsSaga = /*#__PURE__*/_regeneratorRuntime.mark(function readModelsSaga(sagaArgs) {
  var sagaManager, action, query, sagaKey, _query, _sagaKey;

  return _regeneratorRuntime.wrap(function readModelsSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          sagaManager = createSagaManager();

        case 1:
          if (!true) {
            _context.next = 18;
            break;
          }

          _context.next = 4;
          return take([CONNECT_READMODEL, DISCONNECT_READMODEL]);

        case 4:
          action = _context.sent;
          _context.t0 = action.type;
          _context.next = _context.t0 === CONNECT_READMODEL ? 8 : _context.t0 === DISCONNECT_READMODEL ? 12 : 16;
          break;

        case 8:
          query = action.query;
          sagaKey = getHash(query);
          return _context.delegateYield(sagaManager.start("" + CONNECT_READMODEL + sagaKey, connectReadModelSaga, _extends({}, sagaArgs, {
            sagaManager: sagaManager,
            sagaKey: sagaKey
          }), action), "t1", 11);

        case 11:
          return _context.abrupt("break", 16);

        case 12:
          _query = action.query;
          _sagaKey = getHash(_query);
          return _context.delegateYield(sagaManager.start("" + DISCONNECT_READMODEL + _sagaKey, disconnectReadModelSaga, _extends({}, sagaArgs, {
            sagaManager: sagaManager,
            sagaKey: _sagaKey
          }), action), "t2", 15);

        case 15:
          return _context.abrupt("break", 16);

        case 16:
          _context.next = 1;
          break;

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, readModelsSaga);
});

export default readModelsSaga;
//# sourceMappingURL=read-models-saga.js.map